import { DraftState, DraftTextConfiguration, StoreFont } from '@/types';
import { addConfigurationToDraft } from './helper/addConfigurationToDraft';
import { getTextConfigurationBase } from './helper/getTextConfigurationBase';

export const addTextAction =
  (text: string, font: StoreFont, color: string, copyrightError?: string) =>
  (draft: DraftState) => {
    const textConfigurationBase = getTextConfigurationBase(draft, text, font, color);
    if (!textConfigurationBase) {
      // fonts are not supported on the current print area
      return;
    }

    const draftTextConfiguration: DraftTextConfiguration = {
      ...textConfigurationBase,
      type: 'text',
    };

    addConfigurationToDraft(draft, draftTextConfiguration);

    if (copyrightError) {
      const cid = draftTextConfiguration.cid;
      const validation = draft.validation;
      const draftErrors = validation.errors[cid];
      validation.errors[cid] = Object.assign(draftErrors || {}, { copyright: copyrightError });
      validation.valid = false;
    }
  };
